module.exports = __webpack_public_path__ + "img/introducePageTwo_show_two.64cc7a0b.jpg";